import {
    businessType,
    mleTurnOverCategory,
} from 'components/MerchantTab/constant';
import { nameValueOptions } from 'utils/helperMethods';

export const singleValueFields = [
    {
        name: 'legalName',
        label: 'Legal Entity Name',
        type: 'text',
        required: true,
    },
    {
        name: 'panNumber',
        label: 'Entity PAN',
        type: 'text',
        required: true,
    },
    {
        name: 'agreementExpiry',
        label: 'Agreement Expiry (DD/MM/YYYY)',
        type: 'date',
        required: true,
    },
    {
        name: 'dateOfIncorporation',
        label: 'Date of Incorporation (DD/MM/YYYY)',
        type: 'date',
        required: true,
    },
    // {
    //     name: 'turnOver',
    //     label: 'Turnover',
    //     type: 'number',
    //     required: false,
    //     disabled: true,
    // },
    // {
    //     name: 'merchantCategory',
    //     label: 'Merchant Category',
    //     type: 'select',
    //     data: nameValueOptions(mleTurnOverCategory) || [],
    //     required: false,
    // },
    {
        name: 'pinCode',
        label: 'PIN Code',
        type: 'number',
        required: true,
    },
    {
        name: 'state',
        label: 'State',
        type: 'text',
        required: true,
    },
    {
        name: 'city',
        label: 'City',
        type: 'text',
        required: true,
    },
    {
        name: 'relationshipManagerId',
        label: 'Relationship Manager',
        type: 'text',
        required: true,
    },
    {
        name: 'businessType',
        label: 'Constitution Type',
        type: 'select',
        data: nameValueOptions(businessType) || [],
        required: true,
    },
    {
        name: 'authorisedSignatoryPan',
        label: 'Authorized signatory PAN Number',
        type: 'text',
        required: false,
    },
    {
        name: 'authorisedSignatoryDob',
        label: 'Authorized signatory DOB (as per PAN)',
        type: 'date',
        required: false,
    },
    {
        name: 'authorisedSignatoryName',
        label: 'Authorized signatory Name (as per PAN)',
        type: 'text',
        required: false,
    },
    {
        name: 'authorisedSignatoryAddressProofType',
        label: 'Authorised Signatory Address Proof Type',
        type: 'select',
        data:
            nameValueOptions([
                'Driving License',
                'Voter ID',
                'Passport',
                'Electricity Bill',
            ]) || [],
        required: false,
    },
    {
        name: 'authorisedSignatoryAddressProofNo',
        label: 'Authorised Signatory Address Proof Number',
        type: 'text',
        required: false,
    },
    {
        name: 'merchantType',
        label: 'Integration Mode',
        type: 'radio',
        options: nameValueOptions(['Offline', 'Online']) || [],
        required: true,
    },
    {
        name: 'aadharNumber',
        label: 'Aadhar Number (Last 4 Digits only)',
        type: 'number',
        required: false,
    }
];

export const multipleValuesFields = [
    {
        fieldType: 'input',
        label: 'GST Number',
        name: 'gstNumber',
        required: false,
        onlySingleValue: true,
        props: {
            placeholder: 'Enter GST ',
            type: 'text',
        },
    },
    {
        fieldType: 'input',
        label: 'Website/App URLs',
        name: 'websiteURLs',
        required: false,
        props: {
            placeholder: 'Enter Website/App URL ',
            type: 'text',
        },
    },
    {
        fieldType: 'input',
        label: 'Email ID',
        name: 'emailIds',
        required: true,
        props: {
            placeholder: 'Enter Email ID ',
            type: 'text',
        },
    },
    {
        fieldType: 'input',
        label: 'Mobile Number',
        name: 'mobileNumbers',
        required: true,
        props: {
            placeholder: 'Enter Mobile Number ',
            type: 'tel',
        },
    },
];

export const singleUploadFields = [
    {
        fieldType: 'input',
        label: 'AOA (Article of Association)',
        name: 'ARTICLE_OF_ASSOCIATION',
        props: {
            placeholder: 'Upload AOA (Article of Association)',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Agreement',
        name: 'AGREEMENT',
        props: {
            placeholder: 'Upload Agreement',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Power of Attorney / Resolution of managing body',
        name: 'POWER_OF_ATTORNEY',
        props: {
            placeholder: 'Upload Power of Attorney  / Resolution of managing body',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'BO Declaration',
        name: 'BO_DECLARATION',
        props: {
            placeholder: 'Upload BO Declaration',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'BO Identity Proof',
        name: 'BO_IDENTITY_PROOF',
        props: {
            placeholder: 'Upload BO Identity Proof',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Authorised PAN',
        name: 'AUTHORISED_PAN',
        props: {
            placeholder: 'Upload Authorised PAN',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Privacy Policy',
        name: 'PRIVACY_POLICY',
        props: {
            placeholder: 'Upload Privacy Policy',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Partnership Deed',
        name: 'PARTNERSHIP_DEED',
        props: {
            placeholder: 'Upload Partnership Deed',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Board Resolution Document',
        name: 'BR',
        props: {
            placeholder: 'Upload Board Resolution Document',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Web Crawling',
        name: 'WEB_CRAWLING',
        props: {
            placeholder: 'Upload Web Crawling',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Merchant Application Form',
        name: 'MERCHANT_APPLICATION_FORM',
        props: {
            placeholder: 'Upload Merchant Application Form',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Bank Proof',
        name: 'BANK_PROOF',
        props: {
            placeholder: 'Upload Bank Proof',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Customer Grievance Policy',
        name: 'CUSTOMER_GRIEVANCE_POLICY',
        props: {
            placeholder: 'Upload Customer Grievance Policy',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'GST Certificate',
        name: 'GST',
        props: {
            placeholder: 'Upload GST Certificate',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'MEA',
        name: 'MEA',
        props: {
            placeholder: 'Upload MEA',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'MOA (Memorandum of Association)',
        name: 'MEMORANDUM_OF_ASSOCIATION',
        props: {
            placeholder: 'Upload MOA (Memorandum of Association)',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'MOA/Rules/ByLaws- (for societies) / Partnership Deed',
        name: 'UNI_CA_MOA_PARTNERSHIP_DEED',
        props: {
            placeholder: 'Upload MOA/Rules/ByLaws- (for societies)',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'MOA/Rules/ByLaws- (for societies)',
        name: 'JURIDICAL_PERSON_MOA',
        props: {
            placeholder: 'Upload MOA/Rules/ByLaws- (for societies)',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'PAN Upload',
        name: 'PAN',
        props: {
            placeholder: 'Upload PAN',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Permanent Account Number',
        name: 'PERMANENT_ACCOUNT_NUMBER',
        props: {
            placeholder: 'Upload Permanent Account Number',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Proof Principal place of its business (If it is different)',
        name: 'PROOF_PRINCIPLE_PLACE',
        props: {
            placeholder:
                'Upload Proof of Principal place of business (If it is different)',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Proof of Address of the registered office',
        name: 'PROOF_OF_ADDRESS',
        props: {
            placeholder: 'Upload Proof of Address of the registered office',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Refund Policy',
        name: 'REFUND_POLICY',
        props: {
            placeholder: 'Upload Refund Policy',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Website T&C',
        name: 'WEBSITE_TERMS_AND_CONDITION',
        props: {
            placeholder: 'Upload Website T&C',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Authorised signatory - POA',
        name: 'AUTHORISED_SIGNATORY_ADDRESS',
        props: {
            placeholder: 'Upload Authorised Signatory - POA',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Authorised Signatory PAN',
        name: 'AUTHORISED_SIGNATORY_PAN',
        props: {
            placeholder: 'Upload Authorised Signatory PAN',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Proof of business 1',
        name: 'PROOF_BUSINESS_1',
        props: {
            placeholder: 'Upload Proof of business 1',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Proof of business 2',
        name: 'PROOF_BUSINESS_2',
        props: {
            placeholder: 'Upload Proof of business 2',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Registration Certificate',
        name: 'REGISTRATION_CERTIFICATE',
        props: {
            placeholder: 'Upload Registration Certificate',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'List of all members along with their PAN numbers',
        name: 'LISTS_OF_PEOPLE',
        props: {
            placeholder: 'Upload List of all members along with their PAN numbers',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Partnership Deed/Trust deed',
        name: 'TRUST_DEED',
        props: {
            placeholder: 'Upload partnership deed/Trust deed',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'RBI license (Corporative Bank)',
        name: 'RBI_LICENSE',
        props: {
            placeholder: 'Upload RBI license (Corporative Bank)',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Customer Care Channels',
        name: 'CHANNELS',
        props: {
            placeholder: 'Upload Customer Care Channels',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Line of Business verification',
        name: 'LOB_VERIFICATION',
        props: {
            placeholder: 'Upload Line of Business verification',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Ownership Check on Website/App',
        name: 'OWNERSHIP_CHECK',
        props: {
            placeholder: 'Upload Ownership Check on Website/App',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Restricted states (Gaming Merchant)',
        name: 'RESTRICTED_STATES',
        props: {
            placeholder: 'Upload Restricted states (Gaming Merchant)',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Track record 1 year existence - MCA registration',
        name: 'TRACK_RECORD_1_YEAR',
        props: {
            placeholder:
                'Upload Track record 1 year existence - MCA registration',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Authorised Signatory Photograph',
        name: 'AUTHORISED_SIGNATORY_SELFIE',
        props: {
            placeholder: 'Upload Authorised Signatory Photograph',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },





    {
        fieldType: 'file',
        label: 'COI (Certificate of Incorporation)',
        name: 'CERTIFICATE_OF_INCORPORATION',
        props: {
            placeholder: 'Upload COI (Certificate of Incorporation)',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'Bank Letter/Cancelled Cheque',
        name: 'CANCELLED_CHEQUE',
        props: {
            placeholder: 'Upload Bank Letter/Cancelled Cheque',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'Undertaking from merchant (gaming merchant)',
        name: 'UNDERTAKING_MERCHANT_2',
        props: {
            placeholder: 'Upload Undertaking from merchant (gaming merchant)',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'NGO Darpan Registration',
        name: 'NGO_REGISTRATION',
        props: {
            placeholder: 'Upload NGO Darpan Registration',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false
        },
    },
    {
        fieldType: 'file',
        label: 'Screenshot of mail approval incase of insufficient documents',
        name: 'MAIL_APPROVAL_SCREENSHOT',
        props: {
            placeholder:
                'Upload Screenshot of mail approval incase of insufficient documents',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'Website redirection',
        name: 'WEBSITE_REDIRECTION',
        props: {
            placeholder: 'Upload Website redirection',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'Copyright',
        name: 'COPYRIGHT',
        props: {
            placeholder: 'Upload Copyright',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'MCA registration',
        name: 'MCA_REGISTRATION',
        props: {
            placeholder: 'Upload MCA registration',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'All product as per MCA',
        name: 'ALL_MCA_PRODUCTS',
        props: {
            placeholder: 'Upload All product as per MCA',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'Resolution of the managing body of such association or body of individuals',
        name: 'RESOLUTION_OF_THE_MANAGING_BODY',
        props: {
            placeholder: 'Upload Resolution of the managing body of such association or body of individuals',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    }
];

export const singleMultipleUploadFieldsIndividual = [  
    
    {
        fieldType: 'input',
        label: 'Proof of Address of the registered office',
        name: 'BO_ADDRESS',
        props: {
            placeholder: 'Upload Proof of Address of the registered office',
            type: 'file',
            accept: 'image/*, .pdf, .doc, .docx, .msword, .tiff, .pipeg, .gif, , .bmp, .wordprocessingml.document',
            multiple: true,
            required: false,
            count:2,
            mandatory:2
        },
    },

    {
        fieldType: 'input',
        label: 'Shop Pictures',
        name: 'SHOP_PICS',
        props: {
            placeholder: 'Upload Pictures of the Shop',
            type: 'file',
            accept: 'image/*, .pdf, .doc, .docx, .msword, .tiff, .pipeg, .gif, , .bmp, .wordprocessingml.document',
            multiple: true,
            required: false,
            count:4,
            mandatory:4
        },
    },
    {
        fieldType: 'input',
        label: 'Merchant Liveliness Selfie',
        name: 'AUTHORISED_SIGNATORY_SELFIE',
        props: {
            placeholder: 'Upload Merchant Liveliness Selfie',
            type: 'file',
            accept: 'image/*, .pdf, .doc, .docx, .msword, .tiff, .pipeg, .gif, , .bmp, .wordprocessingml.document',
            multiple: true,
            required: false,
            count: 1,
            mandatory:1
        },
    },
]


    export const singleMultipleUploadFieldsSoleProp = [  
        {
            fieldType: 'input',
            label: 'Proof of Address of the registered office',
            name: 'BO_ADDRESS',
            props: {
                placeholder: 'Upload Proof of Address of the registered office',
                type: 'file',
                accept: 'image/*, .pdf, .doc, .docx, .msword, .tiff, .pipeg, .gif, , .bmp, .wordprocessingml.document',
                multiple: true,
                required: false,
                count:2,
                mandatory:1
            },
        },
        {
            fieldType: 'input',
            label: 'GST Certificate',
            name: 'GST',
            props: {
                placeholder: 'Upload GST Certificate',
                type: 'file',
                accept: 'image/*, .pdf, .doc, .docx, .msword, .tiff, .pipeg, .gif, , .bmp, .wordprocessingml.document',
                multiple: true,
                required: false,
                count:2,
                mandatory:0
            },
        },
        {
            fieldType: 'input',
            label: 'Proof of business 1',
            name: 'PROOF_BUSINESS_1',
            props: {
                placeholder: 'Upload Proof of business 1',
                type: 'file',
                accept: 'image/*, .pdf, .doc, .docx, .msword, .tiff, .pipeg, .gif, , .bmp, .wordprocessingml.document',
                multiple: true,
                required: false,
                count:2,
                mandatory:0
            },
        },
        {
            fieldType: 'input',
            label: 'Proof of business 2',
            name: 'PROOF_BUSINESS_2',
            props: {
                placeholder: 'Upload Proof of business 2',
                type: 'file',
                accept: 'image/*, .pdf, .doc, .docx, .msword, .tiff, .pipeg, .gif, , .bmp, .wordprocessingml.document',
                multiple: true,
                required: false,
                count:2,
                mandatory:0
            },
        },
        {
            fieldType: 'input',
            label: 'Shop Pictures',
            name: 'SHOP_PICS',
            props: {
                placeholder: 'Upload Pictures of the Shop',
                type: 'file',
                accept: 'image/*, .pdf, .doc, .docx, .msword, .tiff, .pipeg, .gif, , .bmp, .wordprocessingml.document',
                multiple: true,
                required: false,
                count:4,
                mandatory:1
            },
        },
        {
            fieldType: 'input',
            label: 'Merchant Liveliness Selfie',
            name: 'AUTHORISED_SIGNATORY_SELFIE',
            props: {
                placeholder: 'Upload Merchant Liveliness Selfie',
                type: 'file',
                accept: 'image/*, .pdf, .doc, .docx, .msword, .tiff, .pipeg, .gif, , .bmp, .wordprocessingml.document',
                multiple: true,
                required: false,
                count: 1,
                mandatory: 1
            },
        },
    ]

export const multipleUploadFields = [
    {
        fieldType: 'file',
        label: 'COI (Certificate of Incorporation)',
        name: 'CERTIFICATE_OF_INCORPORATION',
        props: {
            placeholder: 'Upload COI (Certificate of Incorporation)',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'Bank Letter/Cancelled Cheque',
        name: 'CANCELLED_CHEQUE',
        props: {
            placeholder: 'Upload Bank Letter/Cancelled Cheque',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'Undertaking from merchant (gaming merchant)',
        name: 'UNDERTAKING_MERCHANT_2',
        props: {
            placeholder: 'Upload Undertaking from merchant (gaming merchant)',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: true,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'Screenshot of mail approval incase of insufficient documents',
        name: 'MAIL_APPROVAL_SCREENSHOT',
        props: {
            placeholder:
                'Upload Screenshot of mail approval incase of insufficient documents',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: true,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'Website redirection',
        name: 'WEBSITE_REDIRECTION',
        props: {
            placeholder: 'Upload Website redirection',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: true,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'Copyright',
        name: 'COPYRIGHT',
        props: {
            placeholder: 'Upload Copyright',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: true,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'MCA registration',
        name: 'MCA_REGISTRATION',
        props: {
            placeholder: 'Upload MCA registration',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: true,
            required: false,
        },
    },
    {
        fieldType: 'file',
        label: 'All product as per MCA',
        name: 'ALL_MCA_PRODUCTS',
        props: {
            placeholder: 'Upload All product as per MCA',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: true,
            required: false,
        },
    },
];

export const uboSingleUploadFields = [
    {
        fieldType: 'input',
        label: 'UBO PAN Card',
        name: 'panDocs',
        props: {
            placeholder: 'Upload UBO PAN Card',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'UBO Proof of Address',
        name: 'proofOfAddress',
        props: {
            placeholder: 'Upload UBO Proof of Address',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
    {
        fieldType: 'input',
        label: 'UBO Photograph',
        name: 'selfie',
        props: {
            placeholder: 'Upload UBO Photograph',
            type: 'file',
            accept: 'image/*, .pdf',
            multiple: false,
            required: false,
        },
    },
];

export const UBODETAILS = 'uboDetails';
export const BUSINESSDETAILS = 'businessDetails'
export const MERCHANT_TIMELINE_STATUS = {
    Complete: 'Complete',
    Open: 'Open',
    Pending: ''
}

export const BASICFORM_MLE_UPDATE = {
    business: 'mleBusinessDetailUpdateForm',
    ubo:'mleOwnershipDetailUpdateForm'
};

export const EDITABLE = 'Editable';